import types from './types'

export default {
  [types.SET_AFFECTED_ROLE](state, affectedRoleData) {
    state.affectedRoleData = affectedRoleData;
  },
}
